// Centralized mode definitions
export const VIEW_MODES = [
    {
        label: "2D",
        value: "2d",
        showLoader: false,
        loaderText: "Initializing 2D View",
    },
    {
        label: "3D",
        value: "3d",
        showLoader: true,
        loaderText: "Rendering 3D Warehouse",
    },
    // Example future extension:
    // {
    //   label: "4D",
    //   value: "4D,
    //   showLoader: true,
    //   loaderText: "Loading 4d View...",
    // },
];